import React from "react";

import { SharedAvatars } from "../../../../shared-avatars/shared-avatars.component";
import { SharedAvatarsType } from "../../../../../constants/types";

import { AvatarListProps } from "./avatar-list.props";

export const AvatarList = (props: AvatarListProps) => (
  <div className="card-shares">
    {props.users?.length > 0 ? (
      <SharedAvatars type={SharedAvatarsType.LIST_TYPE} people={props.users} />
    ) : (
      <div>{props.noUsersMessage ?? "No Approvers"}</div>
    )}
  </div>
);
